import { GRADIENTS } from "utils/designTokens";

function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, transparentSidenav, locked, miniSidenav = false } = ownerState;

  const { transparent, white } = palette;
  const { xxl } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    position: "relative",
    background: active ? "rgba(96, 165, 250, 0.12)" : transparent.main,
    backdropFilter: active ? "blur(10px)" : "none",
    border: active
      ? "1px solid rgba(96, 165, 250, 0.3)"
      : "1px solid transparent",
    boxShadow: active ? "0 0 14px rgba(96, 165, 250, 0.12)" : "none",
    color: white.main,
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `${pxToRem(9)} ${pxToRem(10)} ${pxToRem(9)} ${pxToRem(12)}`,
    margin: `0 ${miniSidenav ? pxToRem(6) : pxToRem(8)}`,
    borderRadius: borderRadius.lg,
    cursor: locked ? "not-allowed" : "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    opacity: 1,
    pointerEvents: locked ? "none" : "auto",
    transition: transitions.create(
      ["background", "border", "box-shadow", "transform", "backdrop-filter", "opacity"],
      { easing: transitions.easing.easeInOut, duration: transitions.duration.shorter }
    ),
    ...(!active && !locked && {
      "&:hover": {
        background: "rgba(255, 255, 255, 0.05)",
        border: "1px solid rgba(255, 255, 255, 0.09)",
        transform: "translateX(2px)",
      },
    }),
  };
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, boxShadows, borders, functions } = theme;
  const { active } = ownerState;

  const { white } = palette;
  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  const activeBackground = GRADIENTS.text;
  const inactiveBackground = "linear-gradient(135deg, rgba(96,165,250,0.25), rgba(167,139,250,0.2))";

  return {
    width: pxToRem(28),
    height: pxToRem(28),
    borderRadius: borderRadius.button,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: active ? md : "none",
    background: active ? activeBackground : inactiveBackground,
    color: white.main,
    border: active ? "none" : "1px solid rgba(96, 165, 250, 0.2)",
    transition: transitions.create(["background", "box-shadow", "border"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),
  };
}

const collapseIcon = ({ palette: { white } }, { active }) => ({
  color: active ? white.main : white.main,
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size, fontWeightRegular, fontWeightMedium } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(6),

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: "0.8rem",
      lineHeight: 0,
      color: "#ffffff !important",
    },

    [breakpoints.up("md")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(8),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
